import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (total_clicks = 1, t) => [
    {
        label: t('search.subdomains.subdomain'),
        key: 'subdomain',
        data: 'subdomain',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <strong>
                    <a
                        href={`/domains/${window.info.id}/gsc-reports/subdomains/subdomain?subdomain=${data}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.subdomains.traffic_share'),
        key: 'traffic_share',
        data: 'traffic_share',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.clicks / total_clicks;
            return <strong>{numeral(item.clicks / total_clicks).format('0.00%')}</strong>;
        },
    },
    {
        label: t('search.subdomains.avg_weekly_urls'),
        key: 'urls',
        data: 'urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.subdomains.avg_weekly_keywords'),
        key: 'keywords',
        data: 'keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.subdomains.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.subdomains.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.subdomains.avg_position'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('search.subdomains.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            csvDownload ? (
                item.clicks / item.impressions
            ) : (
                <strong>{numeral(item.clicks / item.impressions).format('0.00%')}</strong>
            ),
    },
];
